<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"background:#3B3B3B;\nbackground-image: url(https:\/\/api.kosar-restaurant.ir\/storage\/assets\/background-kosar.jpg);\n"' class="container-fluid" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.kosar-restaurant.ir\/storage\/assets\/logo.png","alt":"\u0631\u0633\u062a\u0648\u0631\u0627\u0646 \u06a9\u0648\u062b\u0631"},...{}}' :style='"height: 400px;\nobject-fit: contain;"' class="col-12 " ></m-img><m-a v-bind='{...{"href":"https:\/\/dash.kosar-restaurant.ir\/dashboard","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-button v-bind='{...{},...{}}' :style='""' class="btn-primary col-6" >
                <template #default>حساب کاربری   </template>
                </m-button></template>
                </m-a><m-div v-bind='{...{},...{}}' :style='""' class="my-5 border shadow bg-white container py-3 rounded col-6" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>تایم کاری رستوران ( ۱۵-۱۱/۳۰ و ۲۳-۱۹ ) بجز روزهای شنبه که رستوران تعطیل می باشد   </template>
                </m-div></template>
                </m-div><m-language-changer-1 v-bind='{...{},...{}}' :style='""' class="text-center my-5" ></m-language-changer-1><m-div v-bind='{...{},...{}}' :style='""' class="mt-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-products-502 v-bind='{...{"perPage":65,"productCardName":"mProductCard208","cardCLass":"my-1","cardWrapperCLass":"col-lg-4 archive-parent-item","showCategoriesSlider":false,"offerType":"number","offerStatus":false,"relatedCurrentCategory":true,"showKeywords":false,"smCardName":"mProductCard208","skeleton":"mProductArchiveSkeleton1","dashboardProduct":false,"publishStatusFilter":false,"image":null,"alt":"mix it web","cardLink":false,"infinityLoading":false,"chooseCategoriesFromTop":false,"cardLinkTarget":"_self","productStoresDirectFilter":null,"orderFilterProp":["brand","feature","category","search","quantity","store","price"],"singleCategory":null,"categoryCard":"mCategoryCardUnKnow300","secondCategoryCard":"mCategoryCardUnKnow301","swiperPerViewSM":2,"swiperPerViewMD":4,"swiperPerViewLG":5},...{}}' :style='""' class="mt-3 m-content-wrapper-fr" ></m-products-502></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mButton from '@moeinmdn/miw-alpha-components/src/package/Tags/Button'; import mLanguageChanger1 from '@moeinmdn/miw-alpha-components/src/package/Language/LanguageChanger/LanguageChanger1'; import mProducts502 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products502/Products502';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mImg,mA,mButton,mLanguageChanger1,mProducts502 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
